var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AutocompleteField',{attrs:{"value":_vm.model,"items":_vm.items,"loading":_vm.loading,"placeholder":_vm.context.attributes.placeholder || 'Type an ICD code or term…'},on:{"input":function($event){_vm.model = $event},"search":_vm.search,"items-clear":function($event){_vm.items = []},"select":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }